import KingOfEth from './KingOfEth'
import React from 'react'

class Games extends React.Component {
  render() {
    return (
      <div>
        <center>
          <h1 className="title is-1">Our Games</h1>
        </center>
        <div className="field">
          <KingOfEth />
        </div>
      </div>
    )
  }
}

export default Games



// WEBPACK FOOTER //
// ./src/Games.js